import { z } from "zod";
import { UserHistoryEntrySchema } from "@/users/models/UserHistoryItem";

export const ListUserHistoryOutputSchema = z.object({
	history: z.array(UserHistoryEntrySchema),
	totalCount: z.number().int(),
	page: z.number().int(),
	pageSize: z.number().int(),
	totalPages: z.number().int(),
});

export type ListUserHistoryOutputType = z.infer<
	typeof ListUserHistoryOutputSchema
>;
